import axios from 'axios';
import {
  HOME_LOAD_EVENTS_BEGIN,
  HOME_LOAD_EVENTS_SUCCESS,
  HOME_LOAD_EVENTS_FAILURE,
  HOME_LOAD_EVENTS_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadEvents(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_LOAD_EVENTS_BEGIN,
    });
    const { projectId, page, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/events`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_LOAD_EVENTS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_LOAD_EVENTS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadEventsError() {
  return {
    type: HOME_LOAD_EVENTS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_LOAD_EVENTS_BEGIN:
      return {
        ...state,
        loadEventsPending: true,
        loadEventsError: null,
      };

    case HOME_LOAD_EVENTS_SUCCESS:
      return {
        ...state,
        loadEventsPending: false,
        loadEventsError: null,
        events: action.data,
      };

    case HOME_LOAD_EVENTS_FAILURE:
      return {
        ...state,
        loadEventsPending: false,
        loadEventsError: action.data.error,
      };

    case HOME_LOAD_EVENTS_DISMISS_ERROR:
      return {
        ...state,
        loadEventsError: null,
      };

    default:
      return state;
  }
}
